import { centsToDollar } from '@shared/utils/currency';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import receiptStyles from '../components/reservationGuestSheetReceipt/ReservationGuestSheetReceipt.scss';
import { useRestaurant } from 'restaurantAdmin/context/useRestaurant';
import { getCurrentTimeOfTheRestaurant } from '@shared/utils/dateFormatters';
import { CancellationFeeAttributes } from './apiHelpers';

export interface GuestReservationCancellationFeeProps {
  cancellationFee: CancellationFeeAttributes;
  className?: string;
}

export const GuestReservationCancellationFee = ({
  cancellationFee,
  className,
}: GuestReservationCancellationFeeProps) => {
  const { timezone } = useRestaurant();

  const processedAtLabel = getCurrentTimeOfTheRestaurant(
    cancellationFee.processedAt?.toString() ?? '',
    timezone,
  );

  return (
    <section className={cx(receiptStyles.section, className)}>
      <h3 className={typography.h7_20}>
        <span>Cancellation Fee</span>
        <span>#{cancellationFee.receiptNumber}</span>
      </h3>
      <dl className={typography.h7}>
        <div>
          <dt>Date Processed</dt>
          <dd>{processedAtLabel}</dd>
        </div>
        <div>
          <dt>Amount</dt>
          <dd>{centsToDollar(cancellationFee.price)}</dd>
        </div>
      </dl>
    </section>
  );
};
